/* frontend/src/pages/SobrePage.js */
import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography } from '../components/ui/typography';
import { Card } from '../components/ui/card';
import ContactForm from '../components/ContactForm';

export default function SobrePage() {
  return (
    <>
      <Helmet>
        <title>Sobre Nós | Seminovos</title>
        <meta name="description" content="Conheça a história, missão e valores da Seminovos. Somos especializados em veículos seminovos com garantia de procedência e qualidade." />
        <meta name="keywords" content="seminovos, sobre nós, carros usados, veículos seminovos, garantia, qualidade" />
        <meta property="og:title" content="Sobre a Seminovos" />
        <meta property="og:description" content="Conheça a história, missão e valores da Seminovos. Somos especializados em veículos seminovos com garantia de procedência e qualidade." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/sobre" />
      </Helmet>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-8 text-center">
          <Typography variant="h1" className="text-4xl font-bold mb-4">
            Sobre Nós
          </Typography>
          <p className="text-muted-foreground text-lg">
            Conheça um pouco mais sobre a nossa história e missão
          </p>
        </div>
        
        <div className="space-y-8">
          <div>
            <Typography variant="h2" className="text-2xl font-semibold mb-4">
              Nossa História
            </Typography>
            <p className="text-muted-foreground mb-4">
              Fundada em 2020, a Seminovos nasceu com o propósito de revolucionar o mercado de veículos seminovos no Brasil. 
              Identificamos uma necessidade no mercado de oferecer veículos seminovos com garantia de procedência, qualidade e 
              transparência em todo o processo de compra.
            </p>
            <p className="text-muted-foreground">
              Com uma equipe de profissionais experientes e apaixonados pelo setor automotivo, rapidamente nos tornamos 
              referência em qualidade e atendimento personalizado. Hoje, contamos com um amplo catálogo de veículos 
              cuidadosamente selecionados para atender às necessidades dos nossos clientes.
            </p>
          </div>
          
          <div>
            <Typography variant="h2" className="text-2xl font-semibold mb-4">
              Nossa Missão
            </Typography>
            <p className="text-muted-foreground">
              Proporcionar a melhor experiência na compra de veículos seminovos, garantindo qualidade, procedência e 
              transparência em todo o processo. Queremos que nossos clientes se sintam seguros e satisfeitos com cada aquisição, 
              construindo uma relação de confiança duradoura.
            </p>
          </div>
          
          <div>
            <Typography variant="h2" className="text-2xl font-semibold mb-4">
              Nossos Valores
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-card p-6 rounded-lg border">
                <h3 className="font-semibold mb-2">Transparência</h3>
                <p className="text-muted-foreground">Compartilhamos todas as informações dos veículos, incluindo histórico completo e possíveis reparos.</p>
              </div>
              <div className="bg-card p-6 rounded-lg border">
                <h3 className="font-semibold mb-2">Qualidade</h3>
                <p className="text-muted-foreground">Todos os nossos veículos passam por rigorosa inspeção técnica antes de serem disponibilizados para venda.</p>
              </div>
              <div className="bg-card p-6 rounded-lg border">
                <h3 className="font-semibold mb-2">Confiança</h3>
                <p className="text-muted-foreground">Construímos relacionamentos duradouros baseados em honestidade e cumprimento dos nossos compromissos.</p>
              </div>
              <div className="bg-card p-6 rounded-lg border">
                <h3 className="font-semibold mb-2">Inovação</h3>
                <p className="text-muted-foreground">Buscamos constantemente novas tecnologias e processos para melhorar a experiência dos nossos clientes.</p>
              </div>
            </div>
          </div>
          
          <div>
            <Typography variant="h2" className="text-2xl font-semibold mb-4">
              Nosso Diferencial
            </Typography>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Veículos com garantia de procedência</li>
              <li>Inspeção técnica completa em mais de 150 itens</li>
              <li>Possibilidade de test drive</li>
              <li>Documentação transparente e sem pendências</li>
              <li>Condições de pagamento flexíveis</li>
              <li>Atendimento personalizado</li>
            </ul>
          </div>
          
          <div className="mt-10 pt-6 border-t">
            <Typography variant="h2" className="text-2xl font-semibold mb-6 text-center">
              Entre em contato
            </Typography>
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  );
}
